import { ListAlt } from '@mui/icons-material'
import DrinkSectionList from './DrinkSectionList'
import DrinkSectionCreate from './DrinkSectionCreate'
import DrinkSectionEdit from './DrinkSectionEdit'

const drinkSectionIndex = {
  icon: ListAlt,
  list: DrinkSectionList,
  edit: DrinkSectionEdit,
  create: DrinkSectionCreate,
}

export default drinkSectionIndex
